<template>
    <div class="ngdialog__header">
        <div v-if="showClose" class="ngdialog-close" @click="$parent.$emit('close')"></div>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'dialog-header',
    props: {
        showClose: {
            type: Boolean,
            default: true
        }
    }
};
</script>
